export const NAVIGATION_TEST_IDS = {
    ROOT: 'navigation-root',
    SKELETON: 'navigation-skeleton',
    LOGO: 'navigation-logo',
    SKIP_TO_MAIN_CONTENT_LINK: 'navbar-skip-to-main-content-link',
    BURGER_BUTTON: 'navigation-burger-button',
    CONTEXT_BAR: 'navigation-context-bar',
    MOBILE_MENU: 'navigation-mobile-menu',
    MOBILE_MENU_ITEM: 'navigation-mobile-menu-item',
    MOBILE_MENU_TITLE: 'navigation-mobile-menu-title',
    MOBILE_MENU_GO_BACK_BUTTON: 'navigation-mobile-menu-go-back-button',
    MAINTENANCE_BANNER: 'navigation-maintenance-banner',
    MAINTENANCE_BANNER_CLOSE_BUTTON: 'navigation-maintenance-banner-close-button',
    MESSAGES: 'navigation-messages',
    MESSAGES_COUNT: 'navigation-messages-count',
    USER: 'navigation-user',
    USER_MENU: 'navigation-user-menu',
    USER_MENU_ITEM: 'navigation-user-menu-item',
};
